import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import { PdfGeneratorStyles as styles } from './Stylesheet.jsx';

export function GeneratePage({ settings }) {

  let missingNumbers: number[] = [];
  let oneHundredArray: number[] = [];
  let remainingNumbers: number[] = [];
  for (let i = 0; i < settings.NumberOfMissingNumbers; i++) {
    
      if (oneHundredArray.length === 0) {
        for (let x = 0; x < 100; x++) {
          oneHundredArray.push(x + 1);
        }
      }  
      
      if (settings.NumberOfMissingNumbers === 100){
      missingNumbers = oneHundredArray;
    }

    remainingNumbers = oneHundredArray;
      
      if (remainingNumbers.length === 0) {
        break;
      }
      

        if (remainingNumbers.length < 20) {
          missingNumbers.push(remainingNumbers[0]);
          remainingNumbers.splice(0, 1);
        }
        else {
          const rndIndex = Math.floor(Math.random() * remainingNumbers.length + 1);
          const missingNumber = remainingNumbers[rndIndex];
          missingNumbers.push(missingNumber);
          remainingNumbers.splice(rndIndex, 1);
        }  
       
  }

  let cells: JSX.Element[] = [];
  if (settings.IsMultiplicationChart) {
    let numberOfCells = 0;   
    for (let i = 1; i <= 10; i++) {      
      if (i === 1) {
        for (let j = 0; j <= 10; j++){
          cells.push(
            (
              <View key={i} style={{...styles.table}}>
                <Text style={{...styles.multiplicationMultiplierChartCell}}>{j !== 0 && j}</Text>
              </View>
            )
          );
        }
      }  
      cells.push(
        (
          <View key={i} style={{...styles.table}}>
            <Text style={{...styles.multiplicationMultiplierChartCell}}>{i}</Text>
          </View>
        )
      );  
      
      for (let k = 1; k <= 10; k++) {
        numberOfCells++;
        const isBlank = !(missingNumbers.indexOf(numberOfCells) >= 0);
        cells.push(
          (
            <View key={i} style={{...styles.table}}>
              <Text style={{...styles.multiplicationChartCell}}>{isBlank && i * k}</Text>
            </View>
          )
        );
      }      
    }
  }
  else {
    for (let i = 1; i <= 100 ; i++) {
      const isBlank = !(missingNumbers.indexOf(i) >= 0);    
      cells.push(
        (
          <View key={i} style={{...styles.table}}>
            <Text style={{...styles.cell}}>{isBlank && i}</Text>
          </View>
        )
      );
    }
  }
     
  return (  
    <View style={{...styles.table}}>
        {cells}
    </View>    
  )
}

